
<template>
  <div >
    <b-card>
      <div class="row ml-1">
        <label class="font-weight-bold"> {{$t('dashboard.applyActivitiesAsTrainee.title')}}</label>
        <b-button
          @click="goTo(`${routes.training.applyActivitiesList}/${$store.state.userInfo.orgMember.id}`)"
          size="sm"
          variant="primary"
          class="ml-auto mr-3 esep-blue-bg text-light"
          v-b-tooltip.hover
          :title="$t('dashboard.applyActivitiesAsTrainee.show')"
        >
          <b-icon icon="arrow-right-circle-fill"></b-icon>
        </b-button>
      </div>
      <b-table
        id="trainings-table"
        perPage="5"
        striped
        hover
        borderless
        :items="applyActivitiesList"
        :fields="fields"
        responsive
        show-empty
        class="mt-2"
        thead-class="esep-blue-bg text-light"
        :busy="isLoading"
      >

        <template v-slot:empty="">
          <h6>{{ $t("dashboard.applyActivitiesAsTrainee.emptyTable") }}</h6>
        </template>
      </b-table>
    </b-card>
    

  </div>
</template>

<script>
import EsepService from "../../services/esep.service";
import { routes } from "../../services/routing.service";
import {handleApiError} from "../../services/error.service";
import { prettifyDate} from '../../services/utils';

export default {

  mounted() {
    this.isLoading =true;
    this.getPendingApplyActivities();
  },
  data() {
    return {
      applyActivitiesList: [],
      fields: [
        { key: "module.title", label: "Εκ. Ενότητα", sortable: true ,filterByFormatted: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "memberValidator", label: "Παραστάτης", sortable: true , thClass: 'text-left', formatter: "formatMemberName",tdClass: 'text-left'},
        { key: "dateAssigned", label: "Ημ/νια Ανάθεσης", sortable: true, formatter: 'prettifyDate'},
      ],
      routes: routes,
      isLoading: false,
    }
  },
  methods: {
    goTo(link) {
      location.replace(link);
    },
    formatMemberName(member){
      return `${member.firstName} ${member.surName}`;
    },
    getPendingApplyActivities() {
      EsepService.getApplyActivitiesByTrainee(this.$store.state.userInfo.orgMember.id).then(
        (response) => {
          this.applyActivitiesList = response.data;
          this.isLoading = false;
        },
        (error) => {
          if(error.response.status == 401 || error.response.status == 403) {
            this.$emit('show-comp',{name: 'activitiesTrainee', value: false});
          } else {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
          
          this.isLoading= false;
        }
      )
    },
    prettifyDate(date) {
      return prettifyDate(date);
    },
   
  }
}
</script>

<style>

</style>